import React, { FC, useState, useEffect } from 'react';
import './App.css';
import { NavbarScroller } from './components/NavbarScroller';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Buy } from './pages/buy';
import { Create } from './pages/create';
import { Home } from './pages/home';
import { Sell } from './pages/sell';
import { Fund } from './pages/fund';

const HARDHAT_NETWORK_ID = '1337';
const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

interface IAppState {
  selectedAddress?: string;
  txBeingSet?: boolean;
  transactionError?: any;
  networkError?: any;
}

const App:FC<IAppState> = (props: IAppState) => {
  useEffect(() => {
    document.title = 'SocialWallet';
  }, []);
  const [selectedAddress, setSelectedAddress] = useState<string>();
  const [networkError, setNetworkError] = useState<string>();
  const [transactionError, setTransactionError] = useState<string>();

  let _provider: any = {};
  let _socialVault: any = {};

  const navigation = {
    brand: { name: "OneXth", to: "/" },
    links: [
      { name: "Home", to: "/" },
      { name: "Buy", to: "/fund" },
      { name: "Sell", to: "/sell" },
      { name: "Create", to: "/create" },
    ]
  }

  const initialState = {
    selectedAddress: '',
    txBeingSent: false,
    transactionError: '',
    networkError: '',
  };

  let state = initialState;

  const { brand, links } = navigation;

  return (
    <>
    <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.2/semantic.min.css"/>
    <div className="App">
      <Router>
        <NavbarScroller
          brand={brand}
          links={links}
          connectWallet={() => _connectWallet()}
          networkError={state.networkError}
          dismiss={() => _dismissNetworkError()}
        />
        <Routes>
          <Route path="/create" element={<Create/>} />
          <Route path="/" element={<Home/>} />
          <Route path="/fund" element={<Fund/>} />
          <Route path="/buy/:address" element={<Buy/>} />
          <Route path="/sell" element={<Sell/>} />
        </Routes>
      </Router>
    </div>
    </>
  )

  async function _connectWallet() {
    const [selectedAddress] = await (window as any).ethereum.request({ method: 'eth_requestAccounts' });

    if (!_checkNetwork()) {
      return;
    }

    _initialize(selectedAddress);

    (window as any).ethereum.on("accountsChanged", ([newAddress]: any) => {
      if (newAddress === undefined) {
        return _resetState();
      }

      _initialize(newAddress);
    });

    (window as any).ethereum.on("networkChanged", ([networkId]: any) => {
      _resetState();
    });
  }

  function _initialize(userAddress: string) {
    setSelectedAddress(userAddress);
  }

  function _resetState() {
    setSelectedAddress(initialState.selectedAddress);
  }

  function _checkNetwork() {
    if ((window as any).ethereum.networkVersion === HARDHAT_NETWORK_ID) {
      return true;
    }

    setNetworkError('Please connect Metamask to Localhost:8545');

    return false;
  }

  function _dismissTransactionError() {
    setTransactionError('');
  }

  function _dismissNetworkError() {
    setNetworkError('');
  }
}

export default App;
